import type { MessageKey } from './en.js';

/** Nederlands. Keukentaal waar die bestaat: post, couverts, mise en place. */
export const nl: Record<MessageKey, string> = {
  'common.loading': 'Laden…',
  'common.save': 'Opslaan',
  'common.saving': 'Opslaan…',
  'common.saved': 'Opgeslagen.',
  'common.cancel': 'Annuleren',
  'common.edit': 'Bewerken',
  'common.delete': 'Verwijderen',
  'common.reallyDelete': 'Echt verwijderen?',
  'common.remove': 'Weghalen',
  'common.reallyRemove': 'Echt weghalen?',
  'common.add': 'Toevoegen',
  'common.create': 'Aanmaken',
  'common.creating': 'Aanmaken…',
  'common.none': 'Geen',
  'common.anyone': 'Iedereen',
  'common.name': 'Naam',
  'common.email': 'E-mail',
  'common.password': 'Wachtwoord',
  'common.station': 'Post',
  'common.anyStation': 'Elke post',
  'common.anywhere': 'Overal',
  'common.optional': 'Optioneel',
  'common.moveUp': 'Omhoog',
  'common.moveDown': 'Omlaag',
  'common.unit': 'Eenheid',
  'common.howMuch': 'Hoeveel',
  'common.amount': 'Hoeveelheid',
  'common.working': 'Berekenen…',
  'common.dismiss': 'Sluiten',
  'common.tryAgain': 'Opnieuw proberen',
  'common.loadFailed':
    'Dit kon niet worden geladen. Controleer de verbinding en probeer het opnieuw.',

  'error.generic': 'Er ging iets mis.',
  'error.notFound': 'Dat is er niet meer. Misschien heeft iemand het verwijderd.',
  'error.validationFailed': 'Er is iets niet goed ingevuld. Kijk het na en probeer het opnieuw.',
  'error.alreadyExists': 'Dat bestaat al.',
  'error.stillReferenced': 'Dat wordt nog ergens anders gebruikt, dus het kan niet weg.',
  'error.invalidData': 'Die waarde mag hier niet.',
  'error.writeInProgress': 'Die wijziging wordt opgeslagen. Probeer het zo opnieuw.',
  'error.backupFileMissing': 'Voeg het back-upbestand toe.',
  'error.onedriveNotConnected': 'Koppel eerst OneDrive.',
  'error.nasAddressNeeded': 'Vul het adres in van de NAS waar back-ups heen gaan.',
  'error.fileTooLarge': 'Dat bestand is te groot.',
  'error.unknownTimeZone': 'Die tijdzone kent deze server niet.',
  'error.alreadySetUp': 'Deze server is al ingesteld.',
  'error.imageType': 'Gebruik een JPEG-, PNG- of WebP-afbeelding.',
  'error.imageMissing': 'Er is geen afbeelding toegevoegd.',
  'error.notADish': 'Alleen een gerecht heeft een gerechtenkaart.',
  'error.logoTooLarge': 'Dat logo is groter dan 2 MB.',
  'error.photoTooLarge': 'Die afbeelding is groter dan 8 MB.',
  'error.taskNotYours': 'Je kunt alleen je eigen naam bij een regel zetten.',
  'error.taskChefOnly':
    'Je kunt een regel starten en afronden, maar alleen een chef kan de tekst wijzigen.',
  'error.staffRank': 'Alleen een beheerder kan personeel van jouw rang of hoger beheren.',
  'error.adminNeedsPassword':
    'Een beheerder heeft een e-mailadres en wachtwoord nodig, niet alleen een pincode.',
  'error.passwordNeedsEmail': 'Inloggen met een wachtwoord vraagt een e-mailadres.',
  'error.noWayToSignIn': 'Dan kunnen ze niet meer inloggen. Geef ze een wachtwoord of een pincode.',
  'error.emailTaken': 'Iemand heeft dat e-mailadres al.',
  'error.lastAdmin':
    'Dit is de laatste beheerder. Maak eerst iemand anders beheerder, anders kan niemand deze keuken beheren.',
  'error.cannotRemoveSelf': 'Je kunt je eigen account niet verwijderen.',
  'error.onlyDishes': 'Alleen gerechten kunnen op een menu: {names}.',
  'error.menuNameTaken': 'Er is al een menu met die naam.',
  'error.menuUnavailable':
    'De allergenen van {names} zijn niet te bepalen, omdat het verwijst naar een recept of ingrediënt dat niet meer bestaat. Herstel eerst het recept.',
  'error.recipeGone': 'Dat recept bestaat niet meer.',
  'error.recipeLoop':
    '{parent} kan {child} niet bevatten, want {child} bevat {parent} al. Dat zou een kringloop zijn.',
  'error.scaleFailed': 'Dat recept kon niet op die hoeveelheid worden uitgerekend.',
  'error.scaleUnits': 'Die hoeveelheid is in een ander soort eenheid dan wat dit recept oplevert.',
  'error.scaleLoop': 'Dit recept bevat zichzelf, dus het kan niet worden omgerekend.',
  'error.scaleNoPortions':
    'Dit recept is niet in porties geschreven. Reken het om per batch of per opbrengst.',
  'error.stillUsed': 'Wordt nog gebruikt door {names}. Haal het daar eerst uit.',
  'error.alreadyInside': 'Dit apparaat zit op het keukennetwerk en heeft geen goedkeuring nodig.',
  'error.allergensUnknown':
    'De allergenen van dit recept zijn niet te bepalen: er ontbreekt iets of het verwijst naar zichzelf. Kijk in de editor wat erin gaat.',
  'error.nameOutsideKitchen':
    'Het keukencertificaat geldt alleen voor het keukennetwerk: adressen zoals 192.168.1.50, en namen die eindigen op .local, .lan, .home of .internal. “{name}” hoort daar niet bij.',
  'error.invalidCredentials': 'Dat klopt niet. Probeer het opnieuw.',
  'error.accountInactive': 'Dat account is niet meer actief.',
  'error.deviceNotEnrolled':
    'Inloggen met een pincode werkt alleen op een tablet die een beheerder heeft aangemeld.',
  'error.notAuthenticated': 'Log in om verder te gaan.',
  'error.forbidden': 'Je rol staat dat niet toe.',
  'error.setupToken':
    'Die installatiecode klopt niet. Kijk in de installatielink die bij de installatie van Mise werd getoond.',
  'error.accountLocked': 'Te veel foute pogingen. Probeer het over 15 minuten opnieuw.',
  'error.accountLockedUntil': 'Te veel mislukte pogingen. Probeer het na {time} opnieuw.',

  'shell.unreachableTitle': 'De server is niet bereikbaar',
  'shell.unreachableBody':
    'Controleer of de Mise-server draait en of dit apparaat op hetzelfde netwerk zit.',
  'shell.home': 'Mise, vandaag',
  'shell.signOut': 'Uitloggen',
  'shell.signOutFailed': 'Uitloggen is mislukt. Controleer de verbinding en probeer het opnieuw.',
  'shell.sourceCode': 'Broncode',
  'shell.language': 'Taal',
  'shell.languageKitchen': 'Taal van de keuken ({language})',

  'nav.today': 'Vandaag',
  'nav.recipes': 'Recepten',
  'nav.dishes': 'Gerechten',
  'nav.ingredients': 'Ingrediënten',
  'nav.settings': 'Instellingen',
  'nav.updateAvailable': 'Er is een nieuwere Mise',

  'role.admin': 'Beheerder',
  'role.head_chef': 'Chef-kok',
  'role.sous_chef': 'Souschef',
  'role.cook': 'Kok',

  'recipeType.dish': 'Gerecht',
  'recipeType.prep': 'Prep',
  'recipeType.component': 'Onderdeel',

  'recipeStatus.draft': 'Concept',
  'recipeStatus.published': 'Gepubliceerd',
  'recipeStatus.archived': 'Gearchiveerd',

  'allergen.gluten': 'Glutenbevattende granen',
  'allergen.crustaceans': 'Schaaldieren',
  'allergen.eggs': 'Eieren',
  'allergen.fish': 'Vis',
  'allergen.peanuts': "Pinda's",
  'allergen.soybeans': 'Soja',
  'allergen.milk': 'Melk',
  'allergen.nuts': 'Noten',
  'allergen.celery': 'Selderij',
  'allergen.mustard': 'Mosterd',
  'allergen.sesame': 'Sesamzaad',
  'allergen.sulphites': 'Zwaveldioxide en sulfieten',
  'allergen.lupin': 'Lupine',
  'allergen.molluscs': 'Weekdieren',

  'today.night': 'Nacht',
  'today.day': 'Dag',
  'today.progress': '{done} van {total} klaar',
  'today.progressLabel': 'Mise en place {period} klaar',
  'today.mine': 'Mijn',
  'today.all': 'Alles',
  'today.nothingMine': 'Er staat niets van jou op deze lijst.',
  'today.nothingStation': 'Niets op deze post.',
  'today.pending_one': 'Eén vinkje is nog niet bij de server aangekomen.',
  'today.pending_other': '{count} vinkjes zijn nog niet bij de server aangekomen.',
  'today.pendingStill': 'Wordt opnieuw geprobeerd. Ze staan op deze tablet tot ze doorkomen.',
  'today.tickRefused': 'Een vinkje is niet doorgekomen: {reason}',

  'task.doneBy': 'Klaar door {name}',

  'line.loading': 'De brigade laden…',
  'line.notEnrolledTitle': 'Deze tablet is niet aangemeld',
  'line.notEnrolledBody':
    'Inloggen met een pincode werkt alleen op een tablet die een beheerder heeft ingesteld. Vraag een beheerder hier in te loggen en de tablet aan te melden via Instellingen.',
  'line.signInPassword': 'Inloggen met wachtwoord',
  'line.whoIsOn': 'Wie staat er?',
  'line.nobodyHasPin':
    'Nog niemand heeft een pincode. Een beheerder kan er per kok een instellen via Instellingen.',
  'line.notOnList': 'Sta je er niet tussen, of zit je op een laptop?',
  'line.signInEmail': 'Inloggen met e-mail en wachtwoord',
  'line.signingIn': 'Inloggen',
  'line.checking': 'Controleren…',
  'line.notMe': 'Niet ik',

  'login.title': 'Log in bij je keuken',
  'login.subtitle': 'Chefs en managers, op elk apparaat.',
  'login.signIn': 'Inloggen',
  'login.signingIn': 'Inloggen…',
  'login.onTheLine': 'Sta je op de lijn?',
  'login.pinLink': 'Inloggen met je pincode',
  'login.eyebrow': 'E-mail en wachtwoord',
  'login.titleKitchen': 'Inloggen bij {kitchen}',
  'login.show': 'Tonen',
  'login.hide': 'Verbergen',
  'login.forgot': 'Wachtwoord vergeten? Een beheerder kan bij Instellingen een nieuw instellen.',
  'login.tabletBody': 'Koks loggen in op de keukentablet: tik je naam aan en voer je pincode in.',
  'login.server': 'Verbonden met {host}',
  'line.eyebrow': 'Keukentablet',
  'line.tapNamePin': 'Tik je naam aan en voer dan je pincode in.',
  'line.enterPin': 'Voer je pincode in.',
  'line.digitsTyped_one': '{count} cijfer ingevoerd',
  'line.digitsTyped_other': '{count} cijfers ingevoerd',
  'line.welcome': 'Welkom, {name}.',
  'line.ok': 'OK',
  'line.clear': 'Wissen',

  'setup.title': 'Deze keuken instellen',
  'setup.body':
    'Deze server is leeg. Geef je keuken een naam en maak het eerste beheerdersaccount aan. Deze pagina zie je maar één keer.',
  'setup.kitchenName': 'Naam van de keuken',
  'setup.kitchenPlaceholder': 'De Gouden Leeuw',
  'setup.yourName': 'Je naam',
  'setup.yourNamePlaceholder': 'Zoals de brigade je kent',
  'setup.passwordHint': 'Minstens 12 tekens.',
  'setup.passwordShort': 'Dat is nog minder dan 12 tekens.',
  'setup.failed': 'Instellen is mislukt. Kijk in het serverlogboek.',
  'setup.create': 'Keuken aanmaken',
  'setup.codeHint':
    'Installeren van buiten het keukennetwerk vraagt om deze code. Het is SETUP_TOKEN in de instellingen van Mise, of het eind van de installatielink die het installatieprogramma toonde. Is er geen ingesteld, dan heeft Mise er zelf een gemaakt en in zijn log gezet.',
  'setup.codeLabel': 'Installatiecode',
  'setup.stepKitchen': 'Restaurant',
  'setup.stepYou': 'Jij',
  'setup.stepBrigade': 'Posten & personeel',
  'setup.stepRecipes': 'Recepten',
  'setup.stepSettings': 'Instellingen',
  'setup.stepCheck': 'Controle',
  'setup.stepOf': 'Stap {current} van {total}',
  'setup.stepShort': 'Stap {current} / {total}',
  'setup.next': 'Volgende',
  'setup.back': 'Terug',
  'setup.skip': 'Nu overslaan',
  'setup.optional': 'Optioneel',
  'setup.required': 'Vul dit eerst in.',
  'setup.kitchenTitle': 'Geef het restaurant een naam',
  'setup.kitchenBody':
    'Deze naam staat bovenaan elk scherm. De taal wordt de standaard van de keuken; iedereen kan nog steeds zijn eigen taal kiezen.',
  'setup.youTitle': 'Jouw account',
  'setup.youBody':
    'Jij bent de beheerder. Je logt in met dit e-mailadres en wachtwoord, op elk apparaat.',
  'setup.emailInvalid': 'Dat lijkt geen e-mailadres.',
  'setup.confirmPassword': 'Wachtwoord nogmaals',
  'setup.showPassword': 'Wachtwoord tonen',
  'setup.passwordMismatch': 'De twee wachtwoorden zijn niet hetzelfde.',
  'setup.passwordMatch': 'De wachtwoorden komen overeen.',
  'setup.brigadeTitle': 'Posten en personeel',
  'setup.brigadeBody':
    'Posten verdelen elke mise-en-placelijst. Begin met de posten die je hebt; je kunt ze later hernoemen of aanvullen.',
  'setup.stationsHeading': 'Posten',
  'setup.stationsEmpty': 'Voeg minstens één post toe.',
  'setup.stationDuplicate': 'Twee posten hebben dezelfde naam.',
  'setup.staffHeading': 'Personeel',
  'setup.staffBody':
    'Koks loggen in op een keukentablet door hun naam aan te tikken en hun pincode in te voeren. Managers kunnen later bij Instellingen een e-mailadres en wachtwoord krijgen.',
  'setup.staffEmpty': 'Nog niemand anders. Voeg je brigade nu toe, of later bij Instellingen.',
  'setup.addPerson': 'Iemand toevoegen',
  'setup.nameMissing': 'Elke regel heeft een naam nodig.',
  'setup.pinInvalid': 'Een pincode is 4 tot 8 cijfers.',
  'setup.yourPin': 'Je pincode (optioneel)',
  'setup.yourPinHint':
    'Zo tik je net als de rest van de brigade in op de keukentablet. Laat leeg om over te slaan; later instellen kan ook.',
  'setup.summaryPin': 'Pincode voor de keukentablet',
  'setup.backupsTitle': 'Back-ups',
  'setup.backupsHint':
    'Mise maakt elke nacht een back-up van de hele keuken. Een kopie ergens anders betekent dat een kapotte schijf of een diefstal de back-ups niet ook meeneemt. Je kunt dit later wijzigen in Instellingen.',
  'setup.backupsTestFirst':
    'Test eerst de verbinding met de NAS, of kies een andere plek voor back-ups.',
  'setup.backupsConnectFirst': 'Koppel eerst OneDrive, of kies een andere plek voor back-ups.',
  'setup.codeForBackups':
    'Nodig om de NAS te testen of OneDrive te koppelen van buiten het keukennetwerk. Het is SETUP_TOKEN in de instellingen van Mise, of de code die Mise in zijn log zette.',
  'setup.recipesTitle': 'Recepten',
  'setup.recipesBody':
    'Zet de gerechten en mise en place die je al kent in het receptenboek: een naam en wat één batch oplevert. Ingrediënten en werkwijze kunnen later.',
  'setup.recipesEmpty':
    'Nog geen recepten. Je kunt dit overslaan en ze later in het receptenboek zetten.',
  'setup.addRecipe': 'Recept toevoegen',
  'setup.recipeName': 'Naam van het recept',
  'setup.recipeType': 'Soort',
  'setup.makes': 'Eén batch levert',
  'setup.recipeDuplicate': 'Twee recepten hebben dezelfde naam.',
  'setup.yieldInvalid': 'Een batch moet meer dan 0 opleveren.',
  'setup.settingsTitle': 'Hoe deze keuken werkt',
  'setup.settingsBody': 'Dit kun je later allemaal wijzigen bij Instellingen.',
  'setup.thisDevice': 'Dit apparaat',
  'setup.enrolDevice': 'Dit apparaat als keukentablet gebruiken',
  'setup.enrolHint':
    'Personeel kan er dan met een pincode op inloggen. Laat dit uit als het je eigen telefoon of laptop is.',
  'setup.deviceName': 'Naam van de tablet',
  'setup.checkTitle': 'Controleren en aanmaken',
  'setup.checkBody':
    'Er wordt niets opgeslagen tot je op aanmaken drukt. Ga terug naar een stap om iets te wijzigen.',
  'setup.summaryNone': 'Geen',
  'setup.summaryAdmin': '{name} · beheerder',
  'setup.summaryTablet': 'Aangemeld als “{name}”',
  'setup.summaryNoTablet': 'Geen keukentablet',
  'setup.defaultLarder': 'Koude keuken',
  'setup.defaultSauce': 'Sauzen',
  'setup.defaultSaute': 'Sauté',
  'setup.defaultGrill': 'Grill',
  'setup.defaultPastry': 'Patisserie',
  'welcome.step0': 'Welkom',
  'welcome.eyebrow': 'Nieuwe server · nog niets ingesteld',
  'welcome.headline': 'Je recepten en je mise en place, op je eigen server.',
  'welcome.lead1': 'Dit is een nieuwe Mise-server. De keuken instellen kost ongeveer vijf minuten.',
  'welcome.lead2':
    'Er wordt niets opgeslagen tot de laatste stap, en alles kan later worden aangepast.',
  'welcome.f1t': 'Recepturen',
  'welcome.f1b':
    'Schaal naar een opbrengst of een aantal couverts, bouw gerechten uit subrecepten, en zie de allergenen van elk subrecept.',
  'welcome.f2t': 'Eén preplijst voor de keuken',
  'welcome.f2b':
    'Chefs zetten erop wat er gemaakt moet worden, per post. Afgevinkte regels verdwijnen twee uur later vanzelf.',
  'welcome.f3t': 'De brigade werkt op een tablet',
  'welcome.f3b':
    'Koks tikken een naam en een pincode, vinken mise en place af en claimen een taak, zodat niets twee keer wordt gemaakt. Elk scherm werkt live bij.',
  'welcome.stepsLabel': 'Instellen · zes stappen',
  'welcome.duration': 'Ongeveer 5 minuten',
  'welcome.readyLabel': 'Klaarleggen',
  'welcome.r1': 'De naam van het restaurant',
  'welcome.r2': 'Een e-mailadres en wachtwoord voor jou, de beheerder',
  'welcome.r3': 'Je posten — koude keuken, sauzen, patisserie, pass',
  'welcome.r4': 'Eventueel je personeel, elk met een pincode van 4–8 cijfers, en een paar recepten',
  'welcome.changeNote': 'Sla over wat je nu niet bij de hand hebt. Niets is definitief.',
  'welcome.selfHost':
    'Alles wat je invult blijft op deze server. Er wordt nergens anders een account aangemaakt, en Mise stuurt niets naar buiten.',
  'welcome.cta': 'Deze keuken instellen',
  'setup.readyLabel': 'Klaar',
  'setup.readyEyebrow': 'Instellen voltooid',
  'setup.readyTitle': '{kitchen} staat klaar.',
  'setup.readyBody': 'De keuken gaat open…',
  'tour.label': 'Rondleiding',
  'tour.promptEyebrow': 'Welkom, {name}',
  'tour.promptTitle': 'Even een korte rondleiding?',
  'tour.promptBody':
    'Eén minuut: waar je mise-en-placelijst staat, hoe je dingen afvinkt en claimt, en waar de recepten staan.',
  'tour.promptNote': 'Dit wordt je maar één keer gevraagd.',
  'tour.start': 'Laat maar zien',
  'tour.notNow': 'Niet nu',
  'tour.skip': 'Rondleiding overslaan',
  'tour.finish': 'Klaar',
  'tour.welcomeTitle': 'Dit is {kitchen}',
  'tour.welcomeBody':
    'Mise bewaart de recepten en mise en place van de keuken op één plek, op je eigen server. Hier vind je alles.',
  'tour.todayBody':
    'Alles wat vandaag gemaakt moet worden, per post. Dit is de pagina waar de lijn mee werkt.',
  'tour.stationsTitle': 'Jouw post',
  'tour.stationsBody': 'Beperk de lijst tot één post, of alleen tot de taken met jouw naam erop.',
  'tour.tickTitle': 'Afvinken',
  'tour.tickBody': 'Tik op een regel als hij klaar is. Hij wordt meteen grijs op elk scherm.',
  'tour.makingBody':
    'Begin je ergens aan? Tik eerst op het kleine vinkje, zodat niemand anders hetzelfde maakt.',
  'tour.addLineTitle': 'Op de lijst zetten',
  'tour.addLineBody':
    'Mise en place gaat met de hand op de doorlopende lijst. Zet je hetzelfde twee keer op, dan telt het op tot één regel.',
  'tour.recipesBody':
    'Elk recept van de keuken, met de allergenen. Schaal het naar wat je nodig hebt, of print het voor de pass.',
  'tour.ingredientsBody': 'Waar de recepten van gemaakt worden, met allergenen en snijverlies.',
  'tour.settingsBody':
    'Posten, personeel en pincodes, keukentablets, gerechtenkaarten en back-ups.',
  'tour.accountTitle': 'Jouw taal',
  'tour.accountBody': 'Kies hier je eigen taal, en log uit als je dienst erop zit.',
  'tour.doneTitle': 'Dat was de rondleiding',
  'tour.doneBody': 'De rest vind je in de balk bovenaan.',

  'task.remove': '{task} van de lijst halen',
  'task.removeConfirm': 'Weghalen?',

  'addTask.what': 'Wat te doen',
  'addTask.placeholder': 'Sjalotten brunoise',
  'addTask.submit': 'Regel toevoegen',
  'addTask.fromBook': 'Uit het receptenboek',
  'addTask.makes': 'levert {amount}',
  'addTask.linked':
    'Gekoppeld aan het recept {name}. Wie het maakt, opent het recept op deze hoeveelheid.',
  'task.recipe': 'Recept',
  'task.openRecipe': 'Open het recept voor {task}',

  'recipes.subtitle':
    'Mise-en-place en componenten. Met Vrij van zie je wat een allergietafel kan krijgen, subrecepten meegeteld. Gerechten hebben een eigen tabblad.',
  'recipes.search': 'Zoek in het boek',
  'recipes.sort': 'Soort',
  'recipes.anySort': 'Elke soort',
  'recipes.prep': 'Prep',
  'recipes.components': 'Onderdelen',
  'recipes.freeFrom': 'Vrij van…',
  'recipes.freeFromOption': 'Vrij van {allergen}',
  'recipes.clearFreeFrom': 'Niet meer filteren op allergeen',
  'recipes.colSortStation': 'Soort · post',
  'recipes.colMakes': 'Opbrengst',
  'recipes.noMatch': 'Niets in het boek komt overeen.',
  'recipes.empty':
    'Het boek is leeg. Begin met een fond of een saus, en bouw daarna de gerechten die ze gebruiken.',
  'recipes.noStation': 'geen post',
  'recipes.noneInTree': 'Geen {allergen}, subrecepten inbegrepen',
  'recipes.portions_one': '{count} portie',
  'recipes.portions_other': '{count} porties',
  'recipes.countFreeFrom': '{shown} van {total} recepten zijn vrij van {allergen}',
  'recipes.countFiltered': '{shown} van {total} recepten',
  'recipes.count_one': '{count} recept in het boek',
  'recipes.count_other': '{count} recepten in het boek',
  'recipes.new': 'Nieuw recept',

  'recipe.back': '← Het boek',
  'recipe.backToBook': 'Terug naar het boek',
  'recipe.makes': 'Levert {amount}',
  'recipe.minutes': '{count} min',
  'recipe.keeps_one': 'Houdbaar {count} uur',
  'recipe.keeps_other': 'Houdbaar {count} uur',
  'recipe.asWritten': 'Zoals geschreven',
  'recipe.scaled': '{factor}× het geschreven recept',
  'recipe.contains': 'Bevat',
  'recipe.nothingDeclarable': 'Niets aan te geven',
  'recipe.mayContain': 'Kan sporen bevatten van {allergens}.',
  'recipe.workedOut': 'Berekend uit de ingrediënten en alle subrecepten.',
  'recipe.empty': 'Dit recept is nog leeg.',
  'recipe.method': 'Bereiding',
  'recipe.storage': 'Bewaren',
  'recipe.print': 'Receptkaart printen',
  'recipe.duplicate': 'Dupliceren',
  'recipe.copyName': '{name} (kopie)',
  'recipe.usedBy': 'Gebruikt in',
  'recipe.level': 'Niv',
  'recipe.what': 'Wat',
  'recipe.open': 'openen',

  'scale.ask': 'Vraag een hoeveelheid',
  'scale.portions': 'Porties',
  'scale.need': 'Ik heb nodig',
  'scale.batches': 'Batches',

  'plating.title': 'Zo gaat het de pas uit',
  'plating.alt': 'Zo gaat het bord de pas uit',
  'plating.remove': 'Foto verwijderen',
  'plating.empty': 'Nog geen foto. Het bord dat een kok namaakt hoort hier, recht van voren.',
  'plating.uploading': 'Uploaden…',
  'plating.add': 'Foto van het bord toevoegen',
  'plating.addAnother': 'Nog een foto toevoegen',

  'print.whatGoesIn': 'Wat erin gaat',

  'editor.editing': 'Bewerken',
  'editor.name': 'Naam van het recept',
  'editor.namePlaceholder': 'Kippenvelouté',
  'editor.status': 'Status',
  'editor.lastSaved': 'Laatst opgeslagen {time}',
  'editor.notSaved': 'Nog niet opgeslagen',
  'editor.colSort': 'Soort',
  'editor.colWhat': 'Wat het is',
  'editor.colNote': 'Notitie',
  'editor.sectionHeading': 'Kopje',
  'editor.removeHeading': 'Kopje weghalen',
  'editor.newSection': 'Onderdeel {count}',
  'editor.notePlaceholder': 'fijngesneden',
  'editor.removeLine': 'Regel weghalen',
  'editor.addLine': 'Regel toevoegen',
  'editor.lines_one': '{count} regel',
  'editor.lines_other': '{count} regels',
  'editor.addSection': 'Kopje toevoegen',
  'editor.hintNext': 'volgende regel',
  'editor.hintField': 'volgend veld',
  'editor.hintMove': 'regel verplaatsen',
  'editor.hintCreate': 'op een onbekende naam maakt hem aan',
  'editor.kindRecipe': 'Recept',
  'editor.kindIngredient': 'Ingrediënt',
  'editor.kindNew': 'Nieuw',
  'editor.theRest': 'De rest',
  'editor.batchMakes': 'Eén batch levert',
  'editor.dishPlates_one': 'Hoeveelheden zijn voor één bord.',
  'editor.dishPlates_other': 'Hoeveelheden zijn voor {count} borden.',
  'editor.yieldUnit': 'Eenheid opbrengst',
  'editor.prepMinutes': 'Prep, minuten',
  'editor.keepsHours': 'Houdbaar, uren',
  'editor.storagePlaceholder': 'Vacuüm, koelcel, gelabeld',
  'editor.tags': 'Labels',
  'editor.tagsPlaceholder': 'pastei, à la carte',
  'editor.mayContain': 'Kan sporen bevatten · alleen kruisbesmetting',
  'editor.rolledUp': 'Opgeteld uit de regels',
  'editor.rollupUnsaved': 'Sla op om de allergenen te berekenen.',
  'editor.rollupContains': 'Bevat {allergens}',
  'editor.rollupNote': 'Bij de laatste keer opslaan, subrecepten inbegrepen.',
  'editor.rollupNone': 'Nergens eronder iets aan te geven, zoals laatst opgeslagen.',
  'editor.stepFirst': 'Zweet de sjalotten aan in boter zonder kleur',
  'editor.stepNext': 'De volgende stap',
  'editor.step': 'Stap {count}',
  'editor.removeStep': 'Stap {count} weghalen',

  'picker.label': 'Wat deze regel is',
  'picker.placeholder': 'Ingrediënt of onderliggend recept',
  'picker.create': 'Ingrediënt aanmaken',
  'picker.creating': 'Aanmaken',

  'ingredients.subtitle':
    'Opbrengst na schoonmaken, dichtheid en gewicht per stuk zorgen dat de lijst zegt hoeveel je uit de koelcel pakt. Je kunt ingrediënten ook direct in de recepteditor toevoegen.',
  'ingredients.search': 'Zoek ingrediënten',
  'ingredients.new': 'Nieuw ingrediënt',
  'ingredients.colYield': 'Rendement',
  'ingredients.colDensity': 'g / ml',
  'ingredients.colEach': 'g per stuk',
  'ingredients.noMatch': 'Niets gevonden.',
  'ingredients.empty': 'Hier staat nog niets.',
  'ingredients.explainTitle': 'Waar de drie getallen voor zijn',
  'ingredients.yieldTitle': 'Rendement.',
  'ingredients.yieldBody':
    'Wat er overblijft na schillen en schoonmaken, als deel van wat je inkoopt: een kilo uien geeft ongeveer 900 g bruikbaar.',
  'ingredients.densityTitle': 'Gram per milliliter.',
  'ingredients.densityBody':
    'Laat een recept in liters een gewicht opleveren, en andersom. Olie is ongeveer 0,92.',
  'ingredients.eachTitle': 'Gram per stuk.',
  'ingredients.eachBody':
    'Maakt van een aantal een gewicht. Een ui is ongeveer 170, een ei ongeveer 50.',
  'ingredients.byVolume': 'Op volume',
  'ingredients.counted': 'Geteld',
  'ingredients.weighed': 'Gewogen',
  'ingredients.category': 'Categorie',
  'ingredients.categoryPlaceholder': 'Groente',
  'ingredients.measured': 'Normaal gemeten',
  'ingredients.optWeight': 'Op gewicht',
  'ingredients.optVolume': 'Op volume',
  'ingredients.optCount': 'Per stuk',
  'ingredients.yieldLabel': 'Rendement, procent',
  'ingredients.yieldHint': 'Wat er overblijft na schillen en schoonmaken. Uien zijn ongeveer 90.',
  'ingredients.densityLabel': 'Gram per milliliter',
  'ingredients.densityHint':
    'Alleen om tussen gewicht en volume om te rekenen. Olie is ongeveer 0,92.',
  'ingredients.eachLabel': 'Gram per stuk',
  'ingredients.eachHint':
    'Alleen om tussen aantal en gewicht om te rekenen. Een ei is ongeveer 50.',
  'ingredients.allergens': 'Allergenen',

  'settings.cookOnly': 'Alleen chefs en beheerders kunnen de inrichting van de keuken wijzigen.',
  'settings.tabStaff': 'Personeel',
  'settings.tabStations': 'Posten',
  'settings.tabDevices': 'Apparaten',
  'settings.tabKitchen': 'Keuken',

  'staff.loadError': 'De personeelslijst kon niet geladen worden.',
  'staff.title': 'Personeel',
  'staff.add': 'Iemand toevoegen',
  'staff.you': '(jij)',
  'staff.pinTag': 'Pincode',
  'staff.passwordTag': 'Wachtwoord',
  'staff.locked': 'Geblokkeerd',
  'staff.namePlaceholder': 'Zoals de brigade diegene kent',
  'staff.role': 'Rol',
  'staff.station': 'Vaste post',
  'staff.noStation': 'Geen vaste post',
  'staff.newPin': 'Nieuwe pincode',
  'staff.keepIt': 'Leeg laten om te behouden',
  'staff.pinPlaceholder': '4 cijfers',
  'staff.pinHint': 'Om in te loggen op een keukentablet.',
  'staff.passwordSection': 'Inloggen met wachtwoord, voor chefs en beheerders',
  'staff.newPassword': 'Nieuw wachtwoord',
  'staff.passwordPlaceholder': 'Minstens 12 tekens',
  'staff.addSubmit': 'Aan de brigade toevoegen',

  'stations.loading': 'Posten laden…',
  'stations.loadError': 'De posten konden niet geladen worden.',
  'stations.title': 'Posten',
  'stations.body':
    'Lijsten worden per post gegroepeerd en in deze volgorde afgedrukt, dus zet ze in de volgorde waarin de keuken is ingedeeld.',
  'stations.empty':
    'Nog geen posten. Een keuken heeft er minstens één nodig voordat een lijst gegroepeerd kan worden.',
  'stations.addLabel': 'Post toevoegen',
  'stations.placeholder': 'Garde-manger',
  'stations.rename': 'Hernoemen',
  'stations.moveEarlier': '{name} naar voren',
  'stations.moveLater': '{name} naar achteren',

  'devices.title': 'Keukentablets',
  'devices.body':
    'Koks kunnen alleen met een pincode inloggen op een aangemelde tablet. Meld aan vanaf de tablet zelf, terwijl je daar als beheerder bent ingelogd.',
  'devices.enrolled': 'Aangemeld {date}',
  'devices.lastUsed': 'laatst gebruikt {date}',
  'devices.neverUsed': 'nooit gebruikt',
  'devices.empty': 'Nog geen tablets aangemeld, dus niemand kan met een pincode inloggen.',
  'devices.enrolLabel': 'Het apparaat waar je nu op zit aanmelden',
  'devices.placeholder': 'Tablet op de pas',
  'devices.enrolling': 'Aanmelden…',
  'devices.enrol': 'Dit apparaat aanmelden',
  'devices.enrolledOk':
    'Aangemeld. Dit apparaat kan nu de personeelslijst tonen en pincodes aannemen.',
  'devices.revokedTitle': 'Ingetrokken',
  'devices.revokedOn': 'ingetrokken {date}',
  'devices.revoke': 'Intrekken',
  'devices.reallyRevoke': 'Echt intrekken?',
  'devices.revokeTitle': 'Logt meteen iedereen uit op {name}',

  'kitchen.loadError': 'De keukeninstellingen konden niet geladen worden.',
  'version.title': 'Versie van Mise',
  'version.running': 'Deze keuken draait Mise {version}.',
  'version.upToDate': 'Dat is de nieuwste versie.',
  'version.newer': 'Mise {version} is uit.',
  'version.whatChanged': 'Wat is er veranderd',
  'version.checkFailed':
    'GitHub was niet bereikbaar om op een nieuwere versie te controleren. Mise probeert het morgen opnieuw.',
  'version.notChecked':
    'Nog niet gecontroleerd. Mise kijkt een minuut na het starten, en daarna eens per dag.',
  'version.checkLabel': 'Eens per dag op een nieuwere versie controleren',
  'version.checkHint':
    'Mise vraagt GitHub welke versie de nieuwste is. Er wordt niets over je keuken verstuurd.',
  'version.howTitle': 'Zo werk je bij',
  'version.backupFirst':
    'Download eerst een back-up. De database werkt zichzelf bij als Mise start.',
  'version.major':
    '{version} is een nieuwe hoofdversie. Lees eerst wat er veranderd is, en zet MISE_VERSION op {major} in .env, of de image-tag op :{major} in TrueNAS.',
  'version.howTrueNas': 'TrueNAS',
  'version.howTrueNasSteps': 'Open Apps, kies de app mise en klik op Update of Pull Images.',
  'version.howInstaller': 'Geïnstalleerd met het installatieprogramma',
  'version.howInstallerSteps': 'Voer in de map mise-kitchen het installatiecommando opnieuw uit:',
  'version.howDocker': 'Gewoon Docker',
  'version.howDockerSteps': 'Voer in de map met compose.yaml uit:',
  'kitchen.title': 'Deze keuken',
  'kitchen.units': 'Eenheden',
  'kitchen.metric': 'Metrisch — grammen en liters',
  'kitchen.imperial': 'Imperiaal — ounces en Amerikaanse cups',
  'kitchen.unitsHint':
    'In welke eenheden nieuwe recepten beginnen. Bestaande recepten houden waarin ze geschreven zijn.',
  'kitchen.language': 'Taal',
  'kitchen.languageHint':
    'De taal van de app voor iedereen die zelf geen taal heeft gekozen. Recepten blijven precies zoals ze zijn ingetypt.',
  'kitchen.retention': 'Verdwenen regels van de doorlopende lijst',
  'kitchen.retentionKeep': 'Bewaren in de database, uit het zicht',
  'kitchen.retentionDelete': 'Verwijderen om ruimte te besparen',
  'kitchen.retentionHint':
    'Bewaarde regels laten zien wie wat wanneer deed, voor latere overzichten, en kosten opslagruimte. Verwijderde regels zijn voorgoed weg.',

  'handover.title': 'Overdracht',
  'handover.empty': 'Laat een notitie achter voor de volgende dienst',
  'handover.placeholder': 'Vis komt later binnen; fond om drie uur opzetten.',
  'handover.save': 'Notitie opslaan',
  'handover.clear': 'Notitie wissen',
  'handover.edit': 'Wijzigen',
  'handover.remove': 'Notitie verwijderen',
  'handover.removeConfirm': 'Verwijderen?',
  'handover.by': '{name}, {when}',
  'running.title': 'De lijst',
  'running.subtitle': 'Eén lijst voor de hele keuken. Afgevinkte regels verdwijnen na twee uur.',
  'running.empty': 'Er staat niets op de lijst. Zet erop wat er moet gebeuren.',
  'running.merged': 'Opgeteld bij de {name} die al op de lijst stond.',
  'running.goneAt': 'weg om {time}',

  'task.beingMade': 'Wordt gemaakt',
  'task.beingMadeBy': 'Wordt gemaakt door {name}',
  'settings.tabBackups': 'Back-ups',
  'backups.title': 'Back-ups',
  'backups.body':
    "Elke nacht bewaart Mise de hele keuken, foto's inbegrepen, in één versleuteld bestand. Bewaar ook een kopie buiten deze machine.",
  'backups.lastGood': 'Laatste back-up: {time}',
  'backups.never': 'Nog geen back-up. De eerste volgt binnen een paar minuten.',
  'backups.failed': 'De laatste back-up is mislukt.',
  'backups.reason.bad_key':
    'Een herstelsleutel bestaat uit 32 letters en cijfers, in groepjes van vier.',
  'backups.reason.wrong_key':
    'Die herstelsleutel opent deze back-up niet, of het bestand is beschadigd.',
  'backups.reason.not_a_backup': 'Dat bestand is geen back-up van Mise.',
  'backups.reason.too_new':
    'Die back-up komt van een nieuwere versie van Mise. Werk deze server eerst bij.',
  'backups.reason.local':
    'Hij kon niet op deze machine worden opgeslagen. Misschien is de schijf vol.',
  'backups.reason.unreachable':
    'Mise kon de NAS niet bereiken. Controleer het adres en of de NAS aan staat.',
  'backups.reason.auth': 'De NAS weigerde de gebruikersnaam of het wachtwoord.',
  'backups.reason.folder': 'Die map bestaat niet op de NAS. Maak hem daar eerst aan.',
  'backups.reason.remote': 'De NAS weigerde het bestand op te slaan.',
  'backups.reason.unknown': 'Er ging iets onverwachts mis. Het serverlog geeft de details.',
  'backups.running': 'Back-up maken…',
  'backups.now': 'Nu back-up maken',
  'backups.download': 'Downloaden',
  'backups.keyTitle': 'Herstelsleutel',
  'backups.keyBody':
    'Een back-up gaat alleen open met deze sleutel. Print hem of schrijf hem op, en bewaar hem ergens anders dan bij deze machine. Zonder sleutel kan niemand een back-up openen.',
  'backups.keyShow': 'Herstelsleutel tonen',
  'backups.keyHide': 'Verbergen',
  'backups.keyPrint': 'Printen',
  'backups.keyConfirm': 'Ik heb hem opgeschreven',
  'backups.keyConfirmed': 'Gemarkeerd als opgeschreven.',
  'backups.keyPrintTitle': 'Herstelsleutel voor {kitchen}',
  'backups.keyPrintBody':
    'Met deze sleutel zet je een back-up van deze keuken terug in Mise. Bewaar hem niet bij de server, maar in de kluis op kantoor of thuis.',
  'backups.whereTitle': 'Waar back-ups heen gaan',
  'backups.onlyHereTitle': 'Back-ups staan alleen op deze machine',
  'backups.onlyHereBody':
    'Gaat die kapot, wordt hij gestolen of faalt de schijf, dan zijn de back-ups ook weg. Stuur ze ook naar een NAS of OneDrive.',
  'backups.onlyHereAction': 'Kies waar ze heen gaan',
  'backups.whereLocal': 'Op deze machine, altijd',
  'backups.whereLocalHint':
    'Deze staan op dezelfde machine als Mise. Gaat die kapot, wordt hij gestolen of faalt de schijf, dan zijn ze ook weg. Download er dus af en toe een, of stuur ze naar een NAS of OneDrive.',
  'backups.whereWebdav': 'Ook naar een NAS of Nextcloud',
  'backups.whereWebdavHint':
    'Via WebDAV, dat Synology, QNAP en Nextcloud allemaal bieden. Er blijft ook een kopie op deze machine.',
  'backups.webdavUrl': 'Adres van de map',
  'backups.webdavUrlHint':
    'Het WebDAV-adres van een map die al bestaat. Gewoon http:// is prima binnen het restaurant.',
  'backups.webdavUser': 'Gebruikersnaam',
  'backups.webdavPassword': 'Wachtwoord',
  'backups.webdavPasswordKept': 'Laat leeg om het opgeslagen wachtwoord te houden.',
  'backups.test': 'Verbinding testen',
  'backups.testing': 'Testen…',
  'backups.testOk': 'Verbonden. Mise kan in die map schrijven.',
  'backups.keepRemote': 'Bewaren op de NAS',
  'backups.keepLocal': 'Bewaren op deze machine',
  'backups.copies_one': '{count} back-up',
  'backups.copies_other': '{count} back-ups',
  'backups.when': 'Nachtelijke back-up om',
  'backups.zone': 'Tijdzone: {zone}.',
  'backups.kept': 'Op deze machine',
  'backups.keptEmpty': 'Hier staat nog niets.',
  'backups.bannerFailed': 'De laatste back-up is mislukt.',
  'backups.bannerStale': 'Er is al twee dagen geen back-up gemaakt.',
  'backups.bannerKey':
    'Niemand heeft de herstelsleutel voor back-ups nog opgeschreven. Zonder sleutel gaat geen enkele back-up open.',
  'backups.bannerAction': 'Naar back-ups',
  'backups.whereOnedrive': 'Ook naar OneDrive',
  'backups.whereOnedriveHint':
    'In de map Apps/Mise van je OneDrive. Mise kan verder niets in je OneDrive zien. Er blijft ook een kopie op deze machine.',
  'backups.onedriveConnect': 'OneDrive koppelen',
  'backups.onedriveStarting': 'Microsoft vragen…',
  'backups.onedriveCodeIntro':
    'Open deze pagina op een telefoon of computer, vul de code hieronder in en log in met het Microsoft-account waarvan de OneDrive de back-ups moet krijgen.',
  'backups.onedriveWaiting': 'Wachten op het inloggen…',
  'backups.onedriveUnverified':
    'Microsoft noemt Mise niet geverifieerd. Dat is normaal voor onafhankelijke apps, en Mise vraagt alleen om zijn eigen map.',
  'backups.onedriveConnected': 'Gekoppeld aan de OneDrive van {account}.',
  'backups.onedriveDisconnect': 'Ontkoppelen',
  'backups.onedrive.declined': 'Het inloggen is bij Microsoft geweigerd.',
  'backups.onedrive.expired': 'De code was verlopen voordat iemand inlogde. Begin opnieuw.',
  'backups.onedrive.failed':
    'Microsoft accepteerde de koppeling niet. Probeer het over een minuut opnieuw.',
  'backups.keepOnedrive': 'Bewaren op OneDrive',
  'backups.keepBoth': 'Bewaren op de NAS en op OneDrive',
  'backups.reason.onedrive_auth':
    'OneDrive laat Mise niet meer toe. Koppel OneDrive opnieuw op de pagina Back-ups.',
  'backups.reason.onedrive_full': 'OneDrive is vol.',
  'backups.reason.onedrive_unreachable':
    'Mise kon OneDrive niet bereiken. Controleer de internetverbinding.',
  'backups.reason.onedrive_failed':
    'OneDrive weigerde de back-up. Mise probeert het over een paar uur opnieuw.',
  'restore.cta': 'Back-up terugzetten',
  'restore.eyebrow': 'Terugzetten',
  'restore.title': 'Een keuken terughalen',
  'restore.body':
    "Kies een back-upbestand en typ de herstelsleutel die erbij is geprint. Personeel, recepten, foto's en preplijsten komen allemaal terug. Daarna logt iedereen opnieuw in.",
  'restore.file': 'Back-upbestand',
  'restore.key': 'Herstelsleutel',
  'restore.keyHint': 'Hoofdletters en streepjes mogen weg.',
  'restore.fileMissing': 'Kies een back-upbestand.',
  'restore.keyMissing': 'Typ de herstelsleutel.',
  'restore.submit': 'Terugzetten',
  'restore.restoring': 'Terugzetten…',
  'restore.working': 'Op een kleine machine kan dit een minuut duren.',
  'restore.done': '{kitchen} is terug',
  'restore.doneBody':
    'Log in met hetzelfde e-mailadres en wachtwoord als eerst. Back-ups blijven op deze machine tot je in Instellingen weer een NAS instelt.',
  'restore.counts': "Personeel: {staff} · Recepten: {recipes} · Foto's: {photos}",
  'restore.signIn': 'Inloggen',
  'restore.asideTitle': 'Wat terugkomt',
  'restore.asideStaff': 'Personeel, met wachtwoorden en pincodes',
  'restore.asideRecipes': "Recepten, ingrediënten en bordfoto's",
  'restore.asidePrep': 'De preplijst',
  'restore.asideTablets': 'Gekoppelde tablets, zolang de server hetzelfde adres houdt',

  // Dish cards
  'recipe.dishCard': 'Gerechtenkaart',
  'editor.frontOfHouse': 'Bediening',
  'editor.frontOfHouseHint': 'Wat de gerechtenkaart de bediening vertelt.',
  'editor.flavour': 'Smaakprofiel',
  'editor.flavourPlaceholder': 'romig, knoflook, fris',
  'editor.temperature': 'Temperatuur',
  'editor.course': 'Menu plaatsing',
  'editor.drinks': 'Bijpassende dranken',
  'editor.drinksPlaceholder': 'Bordeaux wit, kombucha',
  'editor.cutlery': 'Bestek',
  'editor.cutleryPlaceholder': 'kleine lepel',
  'editor.listHint': 'Scheid met komma’s.',
  'editor.notSet': 'Niet ingevuld',
  'temperature.cold': 'Koud',
  'temperature.room': 'Kamertemperatuur',
  'temperature.warm': 'Lauw',
  'temperature.hot': 'Warm',
  'temperature.hot_and_cold': 'Warm en koud',
  'course.amuse': 'Amuse',
  'course.starter': 'Voorgerecht',
  'course.middle': 'Tussengerecht',
  'course.main': 'Hoofdgerecht',
  'course.pre_dessert': 'Pre-dessert',
  'course.dessert': 'Nagerecht',
  'course.mignardise': 'Friandises',
  'course.side': 'Bijgerecht',
  'ingredients.vegan': 'Vegan',
  'ingredients.veganYes': 'Ja',
  'ingredients.veganNo': 'Nee',
  'ingredients.veganUnknown': 'Niet gezegd',
  'ingredients.veganHint':
    'Een gerechtenkaart noemt een gerecht nooit vegan zolang een van de ingrediënten niet gezegd is.',
  'ingredients.whichCereals': 'Welke granen',
  'ingredients.whichNuts': 'Welke noten',
  'ingredients.cerealsPlaceholder': 'tarwe, rogge',
  'ingredients.nutsPlaceholder': 'hazelnoot, walnoot',
  'ingredients.detailsHint':
    'De wet wil dat het graan en de noot op een gerechtenkaart bij naam genoemd worden.',
  'card.title': 'Gerechtenkaart',
  'card.back': '← Het gerecht',
  'card.language': 'Taal van de kaart',
  'card.theme': 'Uiterlijk',
  'card.themeDay': 'Dag',
  'card.themeNight': 'Nacht',
  'card.print': 'Afdrukken',
  'card.download': 'PDF downloaden',
  'card.downloading': 'PDF maken…',
  'card.downloadFailed': 'De PDF kon niet gemaakt worden. Probeer het opnieuw, of druk af.',
  'card.notADish': 'Alleen een gerecht heeft een gerechtenkaart.',
  'card.unavailable':
    'Dit gerecht verwijst naar een recept of ingrediënt dat niet meer bestaat, dus de allergenen kunnen niet worden bepaald. Herstel eerst het recept.',
  'card.noAccess': 'In deze keuken kunnen alleen chefs en beheerders gerechtenkaarten openen.',
  'card.attentionTitle': 'Even nakijken voor het afdrukken',
  'card.attentionVegan':
    'Van deze ingrediënten is niet gezegd of ze vegan zijn: {names}. Tot dat gebeurt, kan de kaart het gerecht geen vegan noemen.',
  'card.attentionDetails': 'Deze bevatten gluten of noten zonder te zeggen welke: {names}.',
  'card.attentionPhoto': 'Dit gerecht heeft nog geen foto.',
  'card.attentionDraft': 'Dit recept is nog een concept.',
  'card.fixIngredients': 'Naar de ingrediënten',
  'card.menu': 'Menu',
  'card.flavour': 'Smaakprofiel',
  'card.temperature': 'Temperatuur',
  'card.course': 'Menu plaatsing',
  'card.components': 'Componenten',
  'card.drinks': 'Bijpassende dranken',
  'card.cutlery': 'Bestek',
  'card.allergens': 'Allergenen',
  'card.component': 'Component',
  'card.vegan': 'Vegan',
  'card.other': 'Overige ingrediënten in het gerecht',
  'card.keyContains': 'bevat',
  'card.keyMayContain': 'kan sporen bevatten',
  'card.keyVegan': 'vegan',
  'card.keyUnknown': 'niet ingevuld',
  'card.cerealsAndNuts': 'Glutenbevattende granen en noten',
  'card.noCerealsOrNuts': 'Geen glutenbevattende granen of noten in dit gerecht.',
  'card.cereals': 'Granen: {names}',
  'card.nuts': 'Noten: {names}',
  'card.unnamed': 'nog niet genoemd',
  'card.printed': 'Afgedrukt {date}',
  'card.page': 'Pagina {page} van {pages}',
  'card.madeWithMise': 'Gemaakt met Mise, vrije software onder de AGPL-3.0',
  'card.noAllergens': 'Geen van de 14 allergenen',
  'card.notVegan': 'Niet vegan',
  'card.veganUnknown': 'Vegan: niet ingevuld',
  'cardAllergen.eggs': 'Ei',
  'cardAllergen.gluten': 'Gluten',
  'cardAllergen.lupin': 'Lupine',
  'cardAllergen.milk': 'Melk',
  'cardAllergen.mustard': 'Mosterd',
  'cardAllergen.sulphites': 'Zwavel\u00addioxide',
  'cardAllergen.molluscs': 'Week\u00addieren',
  'cardAllergen.fish': 'Vis',
  'cardAllergen.soybeans': 'Soja',
  'cardAllergen.sesame': 'Sesam\u00adzaad',
  'cardAllergen.celery': 'Sel\u00adderij',
  'cardAllergen.crustaceans': 'Schaal\u00addieren',
  'cardAllergen.peanuts': 'Pinda',
  'cardAllergen.nuts': 'Noten',
  'settings.tabDishCards': 'Gerechtenkaarten',
  'dishCards.intro':
    'Hoe elke gerechtenkaart in deze keuken eruitziet. Open een kaart vanuit een gerecht.',
  'dishCards.managersOnly':
    'Alleen chefs en beheerders kunnen het uiterlijk van gerechtenkaarten wijzigen.',
  'dishCards.titleLabel': 'Kop',
  'dishCards.titleHint': 'Leeg laten voor “{default}”.',
  'dishCards.locationName': 'Naam van de locatie',
  'dishCards.address': 'Adres',
  'dishCards.logo': 'Logo',
  'dishCards.logoHint': 'JPEG, PNG of WebP, tot 2 MB. Vierkant werkt het best.',
  'dishCards.logoUpload': 'Logo kiezen',
  'dishCards.logoReplace': 'Vervangen',
  'dishCards.logoRemove': 'Verwijderen',
  'dishCards.logoNone': 'Nog geen logo.',
  'dishCards.warning': 'Waarschuwing onderaan elke kaart',
  'dishCards.warningHint':
    'Schrijf hem in elke taal waarin je afdrukt. Een kaart in een taal zonder waarschuwing gebruikt die in de taal van de keuken.',
  'dishCards.warningPlaceholder': 'Deze gerechtenkaart is eigendom van …',
  'dishCards.show': 'Op de kaart',
  'dishCards.part.menu': 'Menu',
  'dishCards.part.flavour': 'Smaakprofiel',
  'dishCards.part.temperature': 'Temperatuur',
  'dishCards.part.course': 'Menu plaatsing',
  'dishCards.part.drinks': 'Bijpassende dranken',
  'dishCards.part.cutlery': 'Bestek',
  'dishCards.part.photo': 'Foto',
  'dishCards.part.logo': 'Logo',
  'dishCards.part.location': 'Locatie en adres',
  'dishCards.part.summary': 'Allergenen op de voorkant',
  'dishCards.part.mayContain': '“Kan sporen bevatten”',
  'dishCards.part.vegan': 'Kolom vegan',
  'dishCards.theme': 'Uiterlijk',
  'dishCards.themeDayHint': 'Wit, zuinig met toner.',
  'dishCards.themeNightHint': 'Donker, het mooist op een scherm of kleurenlaser.',
  'dishCards.access': 'Wie gerechtenkaarten kan openen',
  'dishCards.accessEveryone': 'Iedereen die is ingelogd',
  'dishCards.accessManagers': 'Alleen chefs en beheerders',
  'dishCards.miseLine': 'Elke kaart eindigt met een klein regeltje dat hij met Mise gemaakt is.',
  // Menus
  'nav.menus': 'Menu’s',
  'dishes.subtitle':
    'Elk gerecht als zijn kaart: wat de bediening leest, met de allergenen uitgerekend uit elk subrecept.',
  'dishes.new': 'Nieuw gerecht',
  'dishes.search': 'Zoek een gerecht',
  'dishes.anyCourse': 'Elke gang',
  'dishes.onMenu': 'Alleen op een actief menu',
  'dishes.noMatch': 'Geen gerecht gevonden.',
  'dishes.empty':
    'Nog geen gerechten. Een gerecht is wat naar de pass gaat: voeg er een toe en het staat hier als zijn kaart.',
  'dishes.count_one': '{count} gerecht',
  'dishes.count_other': '{count} gerechten',
  'dishes.countFreeFrom': '{shown} van {total} gerechten zijn vrij van {allergen}',
  'dishes.countFiltered': '{shown} van {total} gerechten',
  'dishes.notOnMenu': 'Niet op een menu',
  'dishes.broken':
    'De allergenen zijn niet uit te rekenen: een subrecept ontbreekt of gebruikt zichzelf.',
  'dishes.openSpec': 'Recept',
  'dishes.print': 'Printen of pdf',
  'dishes.kept':
    'Deze keuken houdt gerechtenkaarten voor chefs en beheerders. Het recept kun je wel openen.',
  'menus.subtitle':
    'De gerechten die de bediening samen verkoopt. Druk het allergenenoverzicht van een menu af, of alle gerechtenkaarten tegelijk.',
  'menus.name': 'Naam van het menu',
  'menus.namePlaceholder': 'Herfstmenu 2026',
  'menus.new': 'Nieuw menu',
  'menus.empty': 'Nog geen menu’s. Begin er een met een naam hierboven.',
  'menus.dishes_one': '{count} gerecht',
  'menus.dishes_other': '{count} gerechten',
  'menuStatus.draft': 'Concept',
  'menuStatus.active': 'Actief',
  'menuStatus.archived': 'Gearchiveerd',
  'menus.back': '← Menu’s',
  'menus.dishesTitle': 'Op het menu',
  'menus.changedCount_one': '{count} gewijzigd sinds de kaarten zijn afgedrukt',
  'menus.changedCount_other': '{count} gewijzigd sinds de kaarten zijn afgedrukt',
  'menus.noDishes': 'Nog geen gerechten op dit menu.',
  'menus.noCourse': 'Geen gang',
  'menus.changed': 'Gewijzigd',
  'menus.removeDish': 'Haal {name} van het menu',
  'menus.addDish': 'Gerecht toevoegen',
  'menus.pickDish': 'Kies een gerecht',
  'menus.allDishesOn': 'Alle gerechten staan al op dit menu.',
  'menus.status': 'Status',
  'menus.description': 'Omschrijving',
  'menus.descriptionPlaceholder':
    'Een paar woorden voor de bediening, zoals de prijs of wanneer het loopt.',
  'menus.overview': 'Allergenenoverzicht',
  'menus.cardsTitle': 'Gerechtenkaarten',
  'menus.cardsProgress': 'Kaart {done} van {total} maken…',
  'menus.allCards': 'Alle gerechtenkaarten (PDF)',
  'menus.lastPrinted': 'Kaarten voor het laatst gedownload op {when}.',
  'menus.neverPrinted': 'De gerechtenkaarten van dit menu zijn nog niet gedownload.',
  'menus.copyName': 'Naam van de kopie',
  'menus.copyPlaceholder': '{name} (kopie)',
  'menus.duplicate': 'Menu kopiëren',
  'menus.delete': 'Menu verwijderen',
  'menus.backToMenu': '← Het menu',
  'menus.overviewTitle': 'Allergenenoverzicht',
  'menus.dish': 'Gerecht',
  'access.eyebrow': 'Buiten de keuken',
  'access.title': 'Vraag toegang',
  'access.body':
    'Buiten de keuken opent Mise alleen op apparaten die de keuken heeft goedgekeurd. Geef dit apparaat een naam en vraag toegang. Een chef of de beheerder keurt het goed bij Instellingen → Apparaten.',
  'access.nameLabel': 'Naam voor dit apparaat',
  'access.namePlaceholder': 'bijv. Telefoon van Sam',
  'access.ask': 'Vraag toegang',
  'access.asking': 'Vragen…',
  'access.waitingTitle': 'Wacht op goedkeuring',
  'access.waitingBody':
    '“{name}” heeft toegang gevraagd. Vraag een chef of de beheerder het goed te keuren bij Instellingen → Apparaten, en lees deze code voor zodat ze weten dat jij het bent:',
  'access.codeLabel': 'Code',
  'access.checking': 'Deze pagina opent Mise vanzelf zodra het is goedgekeurd.',
  'access.whyTitle': 'Waarom vragen?',
  'access.whyBody':
    'Recepten, personeel en allergenen zijn van de keuken. Door eerst te vragen kan niemand op internet zelfs maar bij het inlogscherm komen. Goedkeuring blijft tot ze wordt ingetrokken, of tot dit apparaat 90 dagen niet is gebruikt.',
  'outside.title': 'Buiten de keuken',
  'outside.body':
    'Telefoons en laptops buiten het keukennetwerk of de VPN. Ze zien alleen een aanvraagpagina tot iemand ze hier goedkeurt. Goedkeuring blijft tot je ze intrekt, of tot het apparaat 90 dagen niet is gebruikt.',
  'outside.waiting': 'Wacht op goedkeuring',
  'outside.approved': 'Goedgekeurd',
  'outside.empty':
    'Geen apparaten van buiten. Wie Mise van buiten de keuken opent, kan toegang vragen; die aanvraag verschijnt hier.',
  'outside.code': 'Code',
  'outside.checkCode': 'Keur alleen goed als degene die vraagt dezelfde code op het scherm ziet.',
  'outside.passwordLabel': 'Je wachtwoord',
  'outside.passwordWhy':
    'Je bent buiten de keuken, dus goedkeuren vraagt opnieuw om je wachtwoord.',
  'outside.approve': 'Goedkeuren',
  'outside.deny': 'Weigeren',
  'outside.approvedBy': 'goedgekeurd door {name} op {date}',
  'outside.approvedByFrom': 'goedgekeurd door {name} vanaf {device} op {date}',
  'outside.approvedOn': 'goedgekeurd op {date}',
  'outside.thisDevice': 'Dit apparaat',
  'outside.revokeSelf': 'Dit apparaat moet daarna opnieuw toegang vragen',
  'outside.reallyRevokeSelf': 'Dit apparaat buitensluiten?',
  'error.accessRequired': 'Dit apparaat is niet goedgekeurd voor toegang van buiten de keuken.',
  'error.wrongPassword': 'Dat wachtwoord klopt niet.',
  'error.passwordNeeded':
    'Goedkeuren van buitenaf vraagt een wachtwoord, en dit account heeft er geen. Keur het goed vanuit de keuken.',
  'error.tooManyRequests':
    'Er wachten te veel apparaten op goedkeuring. Probeer het later opnieuw.',
  'settings.tabConnection': 'Verbinding',
  'connection.relayedTitle': 'Mise kan niet zien wie er in de keuken is',
  'connection.relayedBody':
    'Sommige bezoekers bereiken Mise via Dockers eigen doorgifte ({address}), die verbergt waar ze echt zijn. Daarom rekent Mise ze tot buiten de keuken: elk apparaat vraagt één keer toegang aan, en een chef keurt het goed.',
  'connection.relayedTrusted':
    'Sommige bezoekers bereiken Mise via Dockers eigen doorgifte ({address}), die verbergt waar ze echt zijn. Je hebt gekozen ze tot de keuken te rekenen, dus slaan ze de goedkeuring over die apparaten van buiten nodig hebben, waar ze ook zijn.',
  'connection.relayedTrust': 'Reken deze bezoekers tot de keuken',
  'connection.relayedTrustHint':
    'Alleen als Mise niet vanaf internet te bereiken is, of alleen via een webserver die je vertrouwt. Anders slaat iedereen die het vindt de goedkeuring over.',
  'connection.relayedFix':
    'Dit gebeurt met rootless Docker, Podman, Docker Desktop, of via IPv6 als het netwerk van Docker dat niet heeft. Draai Mise met hostnetwerk (network_mode: host), of zet IPv6 aan voor het netwerk van Docker, zodat Mise het eigen adres van elke bezoeker ziet. Zie “From outside the kitchen” in de README.',
  'connection.domainTitle': 'Adres van buitenaf',
  'connection.domainBody':
    'Als Mise via internet bereikbaar is, vul dan het adres in dat ernaartoe leidt, zoals mise.jouwkeuken.nl. Van buiten de keuken antwoordt Mise dan alleen op dat adres: het kale IP-adres, of de naam van een andere website op dezelfde server, vindt niets. Op het keukennetwerk en de VPN blijft elk adres werken.',
  'connection.domainLabel': 'Domein',
  'connection.domainSet': 'Van buitenaf antwoordt Mise alleen op {domain}.',
  'connection.domainUnset':
    'Niet ingesteld: van buitenaf leidt elk adres dat deze server bereikt naar Mise.',
  'connection.domainClear': 'Wissen',
  'connection.domainUseCurrent': 'Gebruik {domain}, het adres waarop je nu zit',
  'connection.domainShared':
    'Andere websites op hetzelfde publieke IP-adres? Wat die nu al serveert (Apache, LiteSpeed of Nginx, vaak ingesteld via een paneel als cPanel of Plesk) moet dit domein doorsturen naar Mise, met de domeinnaam behouden. Draait Mise op een andere verbinding dan die sites, dan is er niets extra nodig.',
  'error.domainLocksYouOut':
    'Je bent verbonden via een ander adres, dus hiermee sluit je jezelf buiten. Stel het in vanuit de keuken, of open Mise eerst via het nieuwe adres.',
  'proxy.title': 'Achter een andere webserver',
  'proxy.body':
    'Beantwoordt een andere webserver op je netwerk (bijvoorbeeld Apache, met je websites) al je domeinen? Laat die je Mise-domein doorsturen, met een eigen certificaat. Mise moet dan weten welke machine dat is, zodat het kan zien wie thuis is en wie buiten.',
  'proxy.trusted': 'Mise gelooft {address} over wie elke bezoeker is.',
  'proxy.none':
    'Geen webserver vertrouwd: alles wat via een andere machine binnenkomt telt als buiten.',
  'proxy.stop': 'Niet meer vertrouwen',
  'proxy.seen': 'Verzoeken voor {host} komen binnen via {address}. Is dat je webserver?',
  'proxy.trust': 'Vertrouw {address}',
  'proxy.addressLabel': 'Of typ het adres van de webserver',
  'proxy.trustTyped': 'Vertrouwen',
  'proxy.apacheTitle': 'Apache instellen',
  'proxy.miseAddress': 'Mise op je netwerk',
  'proxy.step1':
    'Controleer op de Apache-machine of die Mise kan bereiken. Dit hoort "ok" te tonen:',
  'proxy.step1Bridge':
    'Draait Apache in een VM op dezelfde TrueNAS als Mise en komt er niets terug? TrueNAS-VM’s kunnen hun eigen host vaak niet bereiken. Maak in TrueNAS onder Network een bridge (br0), zet het adres van de host daarop en koppel de netwerkkaart van de VM aan br0.',
  'proxy.step2': 'Sla dit op als /etc/apache2/sites-available/mise.conf:',
  'proxy.step3': 'Zet het aan en haal het certificaat op, net als bij je andere sites:',
  'proxy.step4':
    'Open https://{domain} één keer en kom dan hier terug: Mise toont het adres waarlangs het binnenkwam, en dat vertrouw je.',
  'proxy.router':
    'Aan je router verandert niets: poort 80 en 443 gaan al naar Apache. Laat het domein naar je thuis-IP wijzen, net als je andere sites.',
  'proxy.copy': 'Kopiëren',
  'proxy.copied': 'Gekopieerd',
  'error.proxyNotLocal':
    'Gebruik het adres van een webserver op het keukennetwerk, zoals 192.168.1.60.',
  'https.title': 'HTTPS',
  'https.body':
    'Gewoon HTTP blijft altijd werken. Met HTTPS kunnen tablets offline doorwerken en Mise als app installeren, en het is een must voor alles wat via internet bereikbaar is.',
  'https.on': 'Aan',
  'https.off': 'Uit',
  'https.kitchenTitle': 'Op het keukennetwerk',
  'https.kitchenBody':
    'Mise maakt een eigen certificaat voor de adressen die je tablets gebruiken. Geen domein of internet nodig. Elke tablet vertrouwt het één keer, via de vertrouwenspagina.',
  'https.renews': 'Vernieuwt zichzelf. Het huidige geldt tot {date}.',
  'https.trustEachTablet': 'Open op elke tablet één keer deze pagina en volg de stappen:',
  'https.namesLabel': 'Adressen die de tablets gebruiken',
  'https.namesHint':
    'Het adres in de adresbalk van de tablets, zonder http:// of poort. Meerdere? Scheid ze met komma’s.',
  'https.making': 'Maken…',
  'https.turnOn': 'Aanzetten',
  'https.turnOff': 'Uitzetten',
  'https.updateNames': 'Adressen bijwerken',
  'https.portNote':
    'HTTPS antwoordt op poort {port}. Op TrueNAS moet de app die poort ook publiceren.',
  'https.domainTitle': 'Voor je domein',
  'https.domainTitleFor': 'Voor {domain}',
  'https.domainBody':
    'Een gratis certificaat van Let’s Encrypt, dat elke browser vertrouwt zonder stappen op het apparaat. Mise haalt het op en vernieuwt het zelf.',
  'https.domainNeedsAddress': 'Stel eerst hierboven het adres van buitenaf in.',
  'https.domainBehindProxy':
    'Mise staat achter je eigen webserver, die HTTPS voor dit domein regelt. Dit heb je niet nodig.',
  'https.domainStep1': '{domain} wijst naar je publieke IP-adres.',
  'https.domainStep2':
    'Je router stuurt poort 80 door naar poort {http} van Mise, en poort 443 naar poort {https}. Op een cloudserver regelt de installatie dit.',
  'https.domainStep3': 'Vraag dan het certificaat aan:',
  'https.getCertificate': 'Certificaat ophalen',
  'https.asking': 'Let’s Encrypt vragen…',
  'https.askingNote': 'Dit duurt meestal een paar seconden, hooguit twee minuten.',
  'https.failedHint':
    'Meestal komt poort 80 nog niet bij Mise aan, of wijst het domein nog niet hierheen. Let’s Encrypt staat maar een paar mislukte pogingen per uur toe.',
  'https.renewFailed': 'De laatste vernieuwing mislukte; Mise probeert het opnieuw: {reason}',
  'trust.eyebrow': 'Dit apparaat',
  'trust.title': 'Vertrouw het keukencertificaat',
  'trust.body':
    'Eén keer per apparaat. Daarna opent Mise hier via HTTPS, blijft het werken als het netwerk wegvalt en kun je het als app installeren.',
  'trust.notOn':
    'HTTPS staat nog niet aan. Een beheerder zet het aan bij Instellingen → Verbinding.',
  'trust.trusted': 'Dit apparaat vertrouwt het',
  'trust.trustedBody': 'Je zit via HTTPS op Mise. Gebruik voortaan dit adres.',
  'trust.openMise': 'Open Mise',
  'trust.system.ios': 'iPad / iPhone',
  'trust.system.android': 'Android',
  'trust.system.windows': 'Windows',
  'trust.system.mac': 'Mac',
  'trust.system.other': 'Anders',
  'trust.download': 'Download het keukencertificaat.',
  'trust.downloadIos':
    'Download in Safari het keukencertificaat en sta het toe als er naar een configuratieprofiel wordt gevraagd.',
  'trust.downloadButton': 'Certificaat downloaden',
  'trust.ios1':
    'Open Instellingen, tik bovenaan op “Profiel gedownload”, dan op Installeer, en voer je toegangscode in.',
  'trust.ios2': 'Ga naar Instellingen → Algemeen → Info → Certificaatvertrouwensinstellingen.',
  'trust.ios3': 'Zet volledig vertrouwen aan voor “Mise”.',
  'trust.android1':
    'Open Instellingen en zoek op “CA-certificaat” (vaak onder Beveiliging → Versleuteling en inloggegevens → Certificaat installeren).',
  'trust.android2':
    'Kies “CA-certificaat”, tik op “Toch installeren” en kies mise-kitchen.crt uit je downloads.',
  'trust.windows1':
    'Open het gedownloade bestand, kies “Certificaat installeren” en dan “Huidige gebruiker”.',
  'trust.windows2':
    'Kies “Alle certificaten in het onderstaande archief opslaan”, kies “Vertrouwde basiscertificeringsinstanties”, rond af en herstart de browser.',
  'trust.mac1':
    'Open het gedownloade bestand. Sleutelhangertoegang voegt het toe aan je inlogsleutelhanger.',
  'trust.mac2':
    'Dubbelklik op “Mise”, open Vertrouw, en zet “Bij gebruik van dit certificaat” op “Altijd vertrouwen”.',
  'trust.other1':
    'Voeg het gedownloade bestand toe aan de vertrouwde certificeringsinstanties van het systeem of de browser. Firefox heeft een eigen lijst: Instellingen → Privacy & Beveiliging → Certificaten → Autoriteiten → Importeren.',
  'trust.check':
    'Controleer of het gelukt is: dit opent deze pagina via HTTPS. Krijg je een waarschuwing, dan is er een stap overgeslagen.',
  'trust.checkButton': 'Controleren',
  'trust.fingerprint': 'Vingerafdruk, om te vergelijken',
  'error.badName': 'Dat is geen adres of hostnaam. Gebruik iets als 192.168.1.50 of mise.local.',
  'error.noDomain': 'Stel eerst het adres van buitenaf in.',
  'offline.title': 'Offline.',
  'offline.body':
    'Mise is sinds {time} niet bereikbaar. Je ziet wat dit apparaat had, en wijzigingen blijven hier bewaard tot Mise weer antwoordt.',
  'offline.waiting_one': '1 wijziging wacht.',
  'offline.waiting_other': '{count} wijzigingen wachten.',
  'offline.sending_one': '1 wijziging van offline wordt verstuurd…',
  'offline.sending_other': '{count} wijzigingen van offline worden verstuurd…',
  'offline.dropped': '{what} kon niet worden opgeslagen: {reason}',
  'offline.setAside':
    '{what} kon niet worden opgeslagen: Mise liep er tegen een probleem aan. Andere wijzigingen gaan door.',
  'offline.tryAgain': 'Opnieuw proberen',
  'offline.letGo': 'Laten gaan',
  'offline.lineWaiting': 'Wacht op versturen',
  'offline.allergensOnceSent': 'Allergenen worden bijgewerkt zodra je wijzigingen verstuurd zijn.',
  'offline.cardOnceSent': 'Deze kaart wordt bijgewerkt zodra je wijzigingen verstuurd zijn.',
  'offline.menuOnceSent':
    'Allergenen en gerechtenkaarten worden bijgewerkt zodra je wijzigingen verstuurd zijn.',
  'offline.conflictTitle': 'Gewijzigd op een ander apparaat',
  'offline.conflictBody':
    'Terwijl je offline was, heeft iemand anders {what} gewijzigd. Welke versie moet blijven?',
  'offline.yours': 'Die van jou',
  'offline.theirs': 'Nu in Mise',
  'offline.keepMine': 'Die van mij houden',
  'offline.keepTheirs': 'Houden wat in Mise staat',
  'offline.items_one': '1 onderdeel',
  'offline.items_other': '{count} onderdelen',
  'offline.field.note': 'Notitie',
  'offline.field.notes': 'Notities',
  'offline.field.method': 'Bereiding',
  'offline.field.description': 'Omschrijving',
  'offline.field.tags': 'Labels',
  'offline.field.components': 'Onderdelen',
  'offline.field.dishes': 'Gerechten',
  'offline.field.type': 'Soort recept',
  'offline.field.yield': 'Opbrengst',
  'offline.field.portions': 'Porties',
  'offline.field.prepMinutes': 'Voorbereidingstijd',
  'offline.field.cookMinutes': 'Kooktijd',
  'offline.field.keeps': 'Houdbaar',
  'offline.field.allergens': 'Allergenen',
  'offline.field.mayContain': 'Kan sporen bevatten',
  'offline.yes': 'Ja',
  'offline.no': 'Nee',
  'offline.unknownStation': 'Een inmiddels verwijderde post',
  'offline.label.note': 'de overdrachtsnotitie',
  'offline.label.addLine': 'de prepregel “{name}”',
  'offline.label.editLine': 'een wijziging aan een prepregel',
  'offline.label.removeLine': 'het verwijderen van een prepregel',
  'offline.label.recipe': 'het recept “{name}”',
  'offline.label.menu': 'het menu “{name}”',
  'offline.label.ingredient': 'het ingrediënt “{name}”',
  'error.offline':
    'Mise is nu niet bereikbaar, en hiervoor is de verbinding nodig. Probeer het opnieuw zodra die terug is.',
  'prepPrint.print': 'Printen',
  'prepPrint.title': 'Preplijst',
  'prepPrint.empty': 'Niets op de lijst.',
  'prepPrint.line': '{name}, {amount}',
  'recipeCard.makes': 'Opbrengst',
  'recipeCard.prepTime': 'Bereidingstijd',
  'recipeCard.keeps': 'Houdbaar',
  'recipeCard.days_one': '{count} dag',
  'recipeCard.days_other': '{count} dagen',
  'recipeCard.hours_one': '{count} uur',
  'recipeCard.hours_other': '{count} uur',
  'recipeCard.mayContain': 'Kan bevatten: {allergens}',
  'recipeCard.onThePlate': 'Op het bord',
  'recipeCard.plating': 'Opmaak',
  'recipeCard.ownRecipe': 'eigen recept',
  'updated.title': 'Mise is bijgewerkt',
  'updated.body':
    'Mise is bijgewerkt. Herlaad om de nieuwe versie te gebruiken; niets wat nog verstuurd moet worden gaat verloren.',
  'updated.bodyVersion':
    'Mise is bijgewerkt naar {version}. Herlaad om die te gebruiken; niets wat nog verstuurd moet worden gaat verloren.',
  'updated.reload': 'Herladen',
  'error.pageTitle': 'Deze pagina opende niet',
  'error.pageBody': 'Er ging iets mis bij het openen. Herladen lost het meestal op.',
  'access.waitingOne': '“{name}” vraagt toegang van buiten de keuken.',
  'access.waitingCount_one': '1 apparaat vraagt toegang van buiten de keuken.',
  'access.waitingCount_other': '{count} apparaten vragen toegang van buiten de keuken.',
  'access.checkCode': 'Controleer de code en keur goed',
  'error.incompatibleUnits':
    '{child} levert {makes} op, dus het kan hier niet in {unit} worden afgemeten. Gebruik dezelfde soort eenheid, of pas aan wat {child} oplevert.',
  'error.incompatibleUnitsUsedIn':
    '{usedIn} gebruikt {child} in {unit}, en dat is niet uit {makes} af te leiden. Pas eerst die regel aan, of houd de opbrengst in dezelfde soort eenheid.',
  'recipe.shownAsWritten':
    'Dit recept kan niet naar de gevraagde hoeveelheid worden omgerekend, dus je ziet het zoals het geschreven is.',
  'passwordOnly.signIn': 'Inloggen met wachtwoord',
  'passwordOnly.staff':
    'Je bent ingelogd met je pincode. Log in met je wachtwoord om personeel toe te voegen of rollen, wachtwoorden en pincodes te wijzigen.',
  'passwordOnly.devices':
    'Je bent ingelogd met je pincode. Log in met je wachtwoord om tablets te koppelen of apparaten van buitenaf toe te laten.',
  'passwordOnly.connection':
    'Je bent ingelogd met je pincode. Log in met je wachtwoord om te wijzigen hoe Mise bereikbaar is.',
  'passwordOnly.backups':
    'Je bent ingelogd met je pincode. Log in met je wachtwoord om back-ups te beheren of de herstelsleutel te zien.',
  'error.passwordRequired':
    'Log in met je wachtwoord om dit te doen. Met een pincode kan al het andere.',
};
